import { Sparkles, Zap, Lightbulb, Fan, ShieldCheck, Cable, Cpu, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import InteractiveHouse from "../components/InteractiveHouse";

const QUICK_TILES = [
  { to: "/category/switches", label: "Switches", icon: Zap },
  { to: "/category/leds", label: "LED Lights", icon: Lightbulb },
  { to: "/category/fans", label: "Fans", icon: Fan },
  { to: "/category/mcb", label: "MCB & Boards", icon: ShieldCheck },
  { to: "/category/wires", label: "Wires & Cables", icon: Cable },
  { to: "/category/automation", label: "Automation", icon: Cpu },
];

export default function HomePage() {
  return (
    <section className="relative w-full bg-white" data-testid="hero-section">
      {/* Top banner prompting the click interaction */}
      <div className="bg-slate-700 text-white py-3 text-center">
        <p className="font-heading text-sm md:text-base font-medium tracking-[0.15em] uppercase">
          <Sparkles className="w-4 h-4 inline mr-2 text-amber-400 -mt-0.5" />
          <span className="hidden sm:inline">Click on the product you wish to browse</span>
          <span className="sm:hidden">Tap a product below to explore</span>
        </p>
      </div>
      <InteractiveHouse rounded={false} />

      {/* Mobile-only quick category tiles (hidden on md+ where hero fills the screen) */}
      <div className="md:hidden bg-slate-50 border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <p className="text-[11px] uppercase tracking-[0.22em] text-amber-600 font-bold mb-2">
            Browse by category
          </p>
          <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-5 leading-tight">
            What are you shopping for?
          </h2>
          <div className="grid grid-cols-2 gap-3">
            {QUICK_TILES.map((t) => {
              const Icon = t.icon;
              return (
                <Link
                  key={t.to}
                  to={t.to}
                  className="group flex items-center justify-between gap-2 bg-white border border-slate-200 rounded-2xl p-4 hover:border-amber-400 hover:-translate-y-0.5 transition-all"
                  data-testid={`home-tile-${t.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <div className="flex items-center gap-3">
                    <span className="w-9 h-9 grid place-items-center rounded-full bg-amber-500/10 text-amber-600">
                      <Icon className="w-4 h-4" />
                    </span>
                    <span className="font-heading font-medium text-sm text-slate-900 leading-tight">
                      {t.label}
                    </span>
                  </div>
                  <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-amber-600 group-hover:translate-x-0.5 transition-all" />
                </Link>
              );
            })}
          </div>

          <div className="mt-6 rounded-2xl bg-slate-900 text-white p-5 flex items-center justify-between gap-3">
            <div>
              <p className="font-heading font-semibold text-base leading-tight">
                Need a price quote?
              </p>
              <p className="text-slate-400 text-xs mt-1">
                Share your BOQ — we reply within hours.
              </p>
            </div>
            <Link
              to="/boq"
              className="shrink-0 px-4 py-2 bg-amber-500 text-slate-900 rounded-full font-medium text-sm hover:bg-amber-400"
              data-testid="home-cta-boq-mobile"
            >
              Get Quote
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
